module.exports = __webpack_public_path__ + "media/images/close-icon-15b686144397ad7b9cae5a3a36f74f7a.png";